import { LatLng } from './lat-lng';

export interface BubbleOptions {
  position?: LatLng;
}
